import { Injectable } from '@angular/core'
import { Message } from 'primeng/api'
import { BehaviorSubject, Subject } from 'rxjs'
import { GlobalMessagingSeverityConstants } from '../generated/generated'

@Injectable({
  providedIn: 'root',
})
export class MessageBusService {
  private messages: Message[] = []
  messages$: BehaviorSubject<Message[]>
  addedMessage$ = new Subject<Message>()

  constructor() {
    if (localStorage.getItem('notifications')) {
      this.messages = JSON.parse(localStorage.getItem('notifications') as string)
    }

    this.messages$ = new BehaviorSubject<Message[]>(this.messages)
  }

  public setMessages(messages: Message[]) {
    this.messages = messages
    this.messages$.next(this.messages)
    localStorage.setItem('notifications', JSON.stringify(this.messages))
  }

  public clearMessages() {
    this.setMessages([])
  }

  public getMessages() {
    return this.messages
  }

  public createMessage(severity: string, summary: string, detail: string, life: number = 10000) {
    let message: Message = {
      severity: severity.toLowerCase(),
      summary: summary,
      detail: detail,
      life: life,
    }

    return message
  }
  public addSuccessNotification(summary: string, detail?: string) {
    this.addNotification(this.createMessage(GlobalMessagingSeverityConstants.success, summary, detail))
  }
  public addErrorNotification(summary: string, detail?: string) {
    this.addNotification(this.createMessage(GlobalMessagingSeverityConstants.error, summary, detail))
  }
  public addSuccessToast(summary: string, detail?: string) {
    this.addToast(this.createMessage(GlobalMessagingSeverityConstants.success, summary, detail))
  }
  public addErrorToast(summary: string, detail?: string) {
    this.addToast(this.createMessage(GlobalMessagingSeverityConstants.error, summary, detail))
  }

  public addNotification(message: Message, allowDuplicates: boolean = true): void {
    let alreadyNotified = this.messages.some(
      (item) => item.summary == message.summary && item.detail == message.detail && item.severity == message.severity
    )

    if (!alreadyNotified) {
      this.setMessages([...this.messages, message])
      this.addedMessage$.next(message)
    } else {
      if (allowDuplicates) {
        this.addedMessage$.next(message)
      }
    }
  }

  public addToast(message: Message) {
    this.addedMessage$.next(message)
  }
}
